const isLocal = location.hostname === "localhost";
const isDev =
  location.hostname === "www-dev.datajalostamo.fi";
const isTest = location.hostname === "www-testi.datajalostamo.fi"; 
const isProd =
  location.hostname === "www.datajalostamo.fi" ||
  location.hostname === "datajalostamo.fi";
const userSelectedLocale = localStorage.getItem("locale");
const idToken = localStorage.getItem("idToken");

export const environment = {
    // isLocal
  ...(isLocal && {
    envName: "dev",
    apiUrl: "https://localhost:8082/api",
    oidc_client_id: "6203388048389955",
    redirectUrl: "http://localhost:8080",
    grafanaUrl: "https://graphics-dev.datajalostamo.fi", 
    oidc_auth_path: "https://id.datajalostamo.fi/openid/auth",
    logoutUrl: `https://id.datajalostamo.fi/openid/logout?id_token_hint=${idToken}&ui_locales=${userSelectedLocale}&post_logout_redirect_uri=https://www-dev.datajalostamo.fi`,
  }),
  // dev
  ...(isDev && {
    envName: "dev",
    apiUrl: "https://api-dev.datajalostamo.fi/portal/api",
    oidc_client_id: "6203388048389955",
    redirectUrl: "https://www-dev.datajalostamo.fi",
    grafanaUrl: "https://graphics-dev.datajalostamo.fi",
    oidc_auth_path: "https://id.datajalostamo.fi/openid/auth",
    logoutUrl: `https://id.datajalostamo.fi/openid/logout?id_token_hint=${idToken}&ui_locales=${userSelectedLocale}&post_logout_redirect_uri=https://www-dev.datajalostamo.fi`,
  }),
  // test
  ...(isTest && {
    envName: "test",
    apiUrl: "https://api-testi.datajalostamo.fi/portal/api",
    oidc_client_id: "6203388048389955",
    redirectUrl: "https://www-testi.datajalostamo.fi",
    grafanaUrl: "https://graphics-testi.datajalostamo.fi/",
    oidc_auth_path: "https://id.datajalostamo.fi/openid/auth",
    logoutUrl: `https://id.datajalostamo.fi/openid/logout?id_token_hint=${idToken}&ui_locales=${userSelectedLocale}&post_logout_redirect_uri=https://www-testi.datajalostamo.fi`,
  }),
  // prod
  ...(isProd && {
    envName: "prod",
    apiUrl: "https://api.datajalostamo.fi/portal/api",
    oidc_client_id: "9709646899084811",
    redirectUrl: "https://www.datajalostamo.fi",
    grafanaUrl: "https://graphics.datajalostamo.fi",
    oidc_auth_path: "https://id.datajalostamo.fi/openid/auth",
    logoutUrl: `https://id.datajalostamo.fi/openid/logout?id_token_hint=${idToken}&ui_locales=${userSelectedLocale}&post_logout_redirect_uri=https://www.datajalostamo.fi`,
  }),
};
